
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Colombes dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Colombes certifiée Google Partner, soutient les entreprises colombiennes dans l'amélioration de leur visibilité en ligne et la croissance de leur clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Colombes dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Colombes certifiée Google Partner, soutient les entreprises colombiennes dans l'amélioration de leur visibilité en ligne et la croissance de leur clientèle.",
        },
      ],
    };
  },
};
